var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"media-buying-detail media-buying-detail-tb public-table media-buying-ad",class:{
    wavebg: _vm.loading,
  }},[_c('payments-view-table',{ref:"dataTable",attrs:{"statusChannel":_vm.statusChannel,"statusCampaign":_vm.statusCampaign,"activeTab":_vm.activeTab,"table-sorting":_vm.sortings.payments},on:{"update":_vm.update}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }